import { DPR } from '@frameio/utils';
import type { ThemeColorsMeta } from '@frameio/vapor';
import { Avatar as VaporAvatar, AvatarGroup } from '@frameio/vapor';
import {
  getAvatarResizedURL,
  getAvatarSize,
  isThemeMetaColor,
} from '../../../utils';
import type { NotificationGroupInfo } from '../types';
import styles from './Avatars.module.css';
import { useAvatarsData } from './useAvatarsData';

const MAX_AVATARS = 2;

export function Avatars({ id, notificationType }: NotificationGroupInfo) {
  const data = useAvatarsData({
    id,
    notificationType,
  });

  if (!data) return null;

  const { avatars } = data;
  const slicedAvatars = avatars.slice(0, MAX_AVATARS).reverse() || [];
  const size = getAvatarSize(avatars);

  const requestedSize = size * DPR;

  return (
    <AvatarGroup className={styles.styledAvatarGroup} interactive={false}>
      {slicedAvatars.map((avatar, index) => {
        if (!avatar) return null;

        const src = avatar.url
          ? getAvatarResizedURL(avatar.url, requestedSize)
          : undefined;

        let backgroundColor: ThemeColorsMeta = 'default';
        const avatarColor = avatar?.color?.toLowerCase();

        if (isThemeMetaColor(avatarColor)) {
          backgroundColor = avatarColor;
        }

        return (
          <VaporAvatar
            key={`${src}-${index}`}
            alt={avatar.userName}
            background={backgroundColor}
            data-testid="notification-avatar"
            role="img"
            shape="circle"
            size={size}
            src={src}
          />
        );
      })}
    </AvatarGroup>
  );
}
